const _excluded = ["direction", "value", "onChange", "labelClassName", "className", "labels", "max", "justify", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { InputCheckboxButton } from "./input-checkbox-button.component";
import React from 'react';
import { OptionListContainer } from "../../base";
import { produce } from 'immer';
import '@isyc-react/design/main';
import "./input-checkbox-button.style.scss";
import { FormSize } from "../../../../../view-model";
export const InputCheckboxButtonList = props => {
  const {
      direction,
      value,
      onChange,
      labelClassName = 'btn-pill btn-outline-default-primary d-flex align-items-center',
      className,
      labels,
      max,
      justify,
      size = FormSize.SM
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OptionListContainer, {
    className: className,
    direction: direction,
    justify: justify
  }, value === null || value === void 0 ? void 0 : value.map((item, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "p-1"
  }, /*#__PURE__*/React.createElement(InputCheckboxButton, _extends({}, rest, {
    size: size,
    className: labelClassName,
    value: {
      checked: item.checked,
      indeterminate: item.indeterminate,
      data: item.data
    },
    onChange: update => {
      if (value && onChange) {
        const change = produce(value, draft => {
          draft[i] = update;
        });
        const count = change.reduce((sum, item) => item.checked ? ++sum : sum, 0);
        if (max !== undefined && count > max) {
          if (max === 1 && count === 2) {
            const switchValue = [...value].map(item => _objectSpread(_objectSpread({}, item), {}, {
              checked: false
            }));
            switchValue[i] = update;
            onChange(switchValue);
          }
        } else {
          onChange(change);
        }
      }
    }
  }), labels && labels[i] && /*#__PURE__*/React.createElement(React.Fragment, null, labels[i]))))));
};